<div class="page-layout blank p-24" fusePerfectScrollbar>

	<h2>{{'NOT_FOUND.TITLE' | translate}}</h2>
	<p style="display: none;">{{router.url}}</p>
</div>
